export const fadeMaskMotion = {
  initial: { opacity: 0.3 },
  animate: { opacity: 1 },
  transition: { duration: 0.3 },
  exit: { opacity: 0 },
};
